<template>
  <div class="flex items-center">
    <el-avatar
      :shape="shape"
      :size="size"
      :src="_src"
      :style="!_src ? { background: userColor,fontSize: size } : ''"
      class="mr-05"
      @error="onError"
    >
      {{ _src ? '' : name[0] }}
    </el-avatar>
    <div :style="{ color }" class="text-body avatar-info">
      <div v-if="name && showName" class="fw-500">{{ name }}</div>
      <div v-if="additionalInfo" class="text-sm">{{ additionalInfo }}</div>
    </div>
  </div>
</template>
<script setup>
import { computed, ref, watch } from 'vue'

const props = defineProps({
  size: {
    type: Number,
    default: 32,
  },
  shape: {
    type: String,
    default: 'square',
  },
  src: {
    type: String,
    default: '',
  },
  name: {
    type: String,
    default: '',
  },
  additionalInfo: {
    type: String,
    default: null,
  },
  color: {
    type: String,
    default: '#111827',
  },
  showName: {
    default: true,
  },
})

/**
 * Картинка не загрузилась — показываем букву.
 *
 * Ссылки на аватары подписанные и живут сутки: во вкладке, открытой дольше, src протухает.
 * Без этого el-avatar рисовал пустой кружок — буква в слоте появляется только при пустом src.
 */
const _failed = ref(false)

// Новый src — новая попытка: иначе после замены фото кружок так и остался бы с буквой.
watch(() => props.src, () => (_failed.value = false))

const _src = computed(() => (_failed.value ? '' : props.src))

function onError() {
  _failed.value = true
}

// const store = useStore()

/**
 * Цвет подложки под букву — по первому символу имени, чтобы у человека он не прыгал.
 *
 * Остаток берётся по длине массива и без «+1»: прежняя формула `% 5 + 1` давала индексы 1..5,
 * то есть выходила за границы на каждом пятом имени (у всех на «Д», «Й», «О», «У»…) и
 * возвращала undefined — аватар оставался серым. Заодно цвет с индексом 0 не доставался
 * никому.
 */
const availableColors = ['#3b82f6', '#f97316', '#22c55e', '#0abab5', '#a855f7']
const userColor = computed(
  () => availableColors[(props.name?.charCodeAt(0) ?? 0) % availableColors.length],
)
</script>
